import { connect, DataItem } from 'scrivito'

import { Badge } from '@/Atomic/Atoms/Badge'
import { SchemaAttributes } from '@/Data/typesV2'
import { getVariantForEnumValue } from '@/utils/enumGroupVariant'
import { getDisplayValue } from '@/utils/getDisplayValue'

interface CardStatusBadgeProps {
  dataItem: DataItem
  schema: DataItem
}

/**
 * Read-only status badge for the card view. Inline editing is intentionally
 * omitted — status changes are done from the drawer that opens on card tap.
 */
export const CardStatusBadge: React.FC<CardStatusBadgeProps> = connect(
  ({ dataItem, schema }) => {
    const fieldKey = 'status'
    const schemaAttributes = schema.get('attributes') as SchemaAttributes

    const rawValue = dataItem.get(fieldKey)
    const displayValue = getDisplayValue({ rawValue, key: fieldKey, schema })
    const badgeVariant = getVariantForEnumValue(
      schemaAttributes[fieldKey]?.enumValues,
      rawValue,
    )

    if (!displayValue) return null

    return <Badge value={String(displayValue)} variant={badgeVariant} />
  },
)
